import { render, staticRenderFns } from "./Pesan_Banyak.vue?vue&type=template&id=07bc9cd8&"
import script from "./Pesan_Banyak.vue?vue&type=script&lang=js&"
export * from "./Pesan_Banyak.vue?vue&type=script&lang=js&"
import style0 from "./Pesan_Banyak.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports